import React from 'react';
import { ISpecializedCombo, useCombo } from "@hooks/useCombo";
import { MenuItem } from '@material-ui/core';
import { useCaixaService } from '@services/CaixaService';

export enum EnumCaixaTipoLancamento {
    None = 0,
    Credito = 1,
    Debito = 2
}
export default interface ICaixaTipoLancamento {
    caixaTipoLancamentoId: number,
    nome: string,
    ativo: string,
}

export type IComboCaixaTipoLancamento = ISpecializedCombo<ICaixaTipoLancamento>;

export function useCaixaTipoLancamentoCombo (initialValue: EnumCaixaTipoLancamento) : IComboCaixaTipoLancamento {
    const combo = useCombo<ICaixaTipoLancamento>({
        value: initialValue
    });

    const caixaService = useCaixaService();

    const loadOptions = React.useCallback(() => {
        combo.load(caixaService.listarTiposLancamentoAtivos);
    }, [caixaService.listarTiposLancamentoAtivos, combo]);

    const createOptions = React.useCallback(() => {
        return combo.set.map((caixaTipoLancamento, index) => <MenuItem key={index} value={caixaTipoLancamento.caixaTipoLancamentoId}>{ caixaTipoLancamento.nome }</MenuItem>)
    }, [combo.set]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}